import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { Room, LocalVideoTrackPublication, RemoteVideoTrackPublication } from 'twilio-video'
import uniq from 'lodash/uniq'
import isScreenshareTrack from '../../../lib/isScreenshareTrack'
import { isDialIn, isPresenter, isObserver } from '../../../lib/username/username'
import getPresentersFromSeatingOrder from '../getPresentersFromSeatingOrder'

const getEnabledTracks = (state: State): string[] => state.tracks.enabledVideoTracks
const getHiddenList = (state: State): string[] => state.syncUi.videoDisplay
const getRoom = (state: State): Room | null => state.room.room

/**
 * Fetches all enabled video tracks
 * @param state The Redux state
 */

export default createSelector(
  [
    getPresentersFromSeatingOrder,
    getHiddenList,
    getEnabledTracks,
    getRoom
  ],
  (presentersFromSeating, hiddenParticipant, enabledTracks, room): (LocalVideoTrackPublication | RemoteVideoTrackPublication)[] => {

    if (!room) return []

    const presenters = presentersFromSeating.map(({id}) => id)
    const visibleParticipants: string[] = uniq(presenters)
      .filter(_identity => !hiddenParticipant.includes(_identity))

    const publications: (LocalVideoTrackPublication | RemoteVideoTrackPublication)[] = []

    if (visibleParticipants.includes(room.localParticipant.identity)) {

      for (const [ , publication ] of room.localParticipant.videoTracks.entries()) {

        if (enabledTracks.includes(publication.trackSid)) publications.push(publication)

      }

    }
    else {

      for (const [ , publication ] of room.localParticipant.videoTracks.entries()) {

        if (enabledTracks.includes(publication.trackSid) && isScreenshareTrack(publication)) publications.push(publication)

      }

    }

    for (const [ , participant ] of room.participants.entries()) {

      if (!isPresenter(participant.identity) && !isObserver(participant.identity) &&  !isDialIn(participant.identity)) continue

      if (visibleParticipants.includes(participant.identity)) {

        for (const [ , publication ] of participant.videoTracks.entries()) {

          if (enabledTracks.includes(publication.trackSid)) publications.push(publication)

        }

      }
      else {

        for (const [ , publication ] of participant.videoTracks.entries()) {

          if (enabledTracks.includes(publication.trackSid) && isScreenshareTrack(publication)) publications.push(publication)

        }

      }

    }

    return publications

  })
